"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorTransformDestinationAlpha = void 0;
var tslib_1 = require("tslib");
var alpha_color_transform_1 = require("../../../../../../core/model/drawing/transform/alpha-color-transform");
var color_transform_destination_base_1 = require("./color-transform-destination-base");
var ColorTransformDestinationAlpha = (function (_super) {
    tslib_1.__extends(ColorTransformDestinationAlpha, _super);
    function ColorTransformDestinationAlpha() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorTransformDestinationAlpha.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.color.transforms.add(new alpha_color_transform_1.AlphaColorTransform(this.getIntegerValue(reader)));
                return [2];
            });
        });
    };
    return ColorTransformDestinationAlpha;
}(color_transform_destination_base_1.ColorTransformDestinationBase));
exports.ColorTransformDestinationAlpha = ColorTransformDestinationAlpha;
